import { render, staticRenderFns } from "./TabelaResultadosHome.vue?vue&type=template&id=7c344670&scoped=true&"
import script from "./TabelaResultadosHome.vue?vue&type=script&lang=js&"
export * from "./TabelaResultadosHome.vue?vue&type=script&lang=js&"
import style0 from "./TabelaResultadosHome.vue?vue&type=style&index=0&id=7c344670&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c344670",
  null
  
)

export default component.exports